import {
  ContactByIdResolver,
  ContactsCountriesResolver,
  ContactsCategoriesResolver,
  ContactTaskResolver,
} from './contacts.resolvers';
import { Route } from '@angular/router';
import { ContactsComponent } from './contacts.component';
import { CanDeactivateContactsDetails } from './contacts.guards';
import { ContactsListComponent } from './list/list.component';
import { ContactsDetailsComponent } from './details/details.component';
import { ContactTaskDetailsComponent } from './task/contact-task-details.component';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from '../projects/projects.resolvers';
import { SavedViewResolver, SavedViewsResolver } from 'app/core/resolvers/saved-views.resolver';
import { TaskFieldDefsResolver } from 'app/shared/modules/legacy-tasks/tasks.resolvers';
import { SettingsUsersResolver } from '../settings/settings.resolvers';
import { RelatedToType } from 'app/shared/enums';
import { TaskDetailsComponent } from '@tasks/task-details/task-details.component';

export const contactsRoutes: Route[] = [
  {
    path: '',
    component: ContactsComponent,
    resolve: {
      users: SettingsUsersResolver,
      savedViews: SavedViewsResolver,
      options: ProjectDataResolver,
    },
    data: {
      fromProject: false,
    },
    children: [
      {
        path: ':saved_view_id/table',
        component: ContactsListComponent,
        resolve: {
          categories: ContactsCategoriesResolver,
          savedViews: SavedViewsResolver,
          savedView: SavedViewResolver,
          fieldDefs: ProjectsFieldDefsResolver,
        },
      },
      {
        path: ':id',
        component: ContactsDetailsComponent,
        resolve: {
          contact: ContactByIdResolver,
          categories: ContactsCategoriesResolver,
          fieldDefs: ProjectsFieldDefsResolver,
          taskFieldDefs: TaskFieldDefsResolver,
        },
        data: {
          relatedToType: RelatedToType.Contact,
        },
        canDeactivate: [CanDeactivateContactsDetails],
        children: [
          {
            path: ':task_list_id/:task_id',
            component: TaskDetailsComponent,
            canDeactivate: [CanDeactivateContactsDetails],
            outlet: 'task',
          },
          {
            path: 'custom_object',
            data: {
              relatedTo: RelatedToType.Contact,
            },
            loadChildren: () =>
              import('../../shared/modules/custom-objects/custom-objects.module').then((m) => m.CustomObjectsModule),
          },
        ],
      },
    ],
  },
];
